import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('service_area', '/service_areas')
const reducer = generator.generate()

export default reducer
